import { handleBridgePrompt } from '../../agents/acp/from-bridge/handle-bridge-prompt.js';
import type { MessageHandlerDeps } from '../../routing/message-handler-deps.js';
import type { ApiToBridgePromptMessage } from '../../types/api-to-bridge-messages.js';
import type { PersistedPromptTurn } from '../disk-store.js';

export function dispatchLocalPrompt(next: PersistedPromptTurn, deps: MessageHandlerDeps): void {
  const pl = next.payload;
  const rawParent = pl['sessionParent'];
  const sessionParent =
    rawParent === 'bridge_root' || rawParent === 'worktrees_root' ? rawParent : undefined;
  const rawParentPath = pl['sessionParentPath'];
  const sessionParentPath =
    typeof rawParentPath === 'string' && rawParentPath.trim() !== '' ? rawParentPath.trim() : undefined;
  const rawBaseBranches = pl['worktreeBaseBranches'];
  const worktreeBaseBranches =
    rawBaseBranches != null &&
    typeof rawBaseBranches === 'object' &&
    !Array.isArray(rawBaseBranches)
      ? (rawBaseBranches as Record<string, string>)
      : undefined;
  const msg: ApiToBridgePromptMessage = {
    type: 'prompt',
    sessionId: next.sessionId,
    runId: next.turnId,
    prompt: pl.prompt,
    mode: typeof pl.mode === 'string' ? pl.mode : 'agent',
    isNewSession: pl.isNewSession === true,
    ...(sessionParent ? { sessionParent } : {}),
    ...(sessionParentPath ? { sessionParentPath } : {}),
    ...(worktreeBaseBranches && Object.keys(worktreeBaseBranches).length > 0
      ? { worktreeBaseBranches }
      : {}),
    ...(typeof pl.followUpCatalogPromptId === 'string' ? { followUpCatalogPromptId: pl.followUpCatalogPromptId } : {}),
    ...(typeof pl.agentType === 'string' && pl.agentType.trim() ? { agentType: pl.agentType.trim() } : {}),
    ...(pl.agentConfig != null &&
    typeof pl.agentConfig === 'object' &&
    !Array.isArray(pl.agentConfig) &&
    Object.keys(pl.agentConfig).length > 0
      ? { agentConfig: pl.agentConfig as Record<string, unknown> }
      : {}),
    ...(Array.isArray(pl.attachments) && pl.attachments.length > 0
      ? { attachments: pl.attachments }
      : {}),
  };
  handleBridgePrompt(msg, deps);
}
